import { useHabits } from 'features/tasks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Section, Sizes } from 'shared/components/ui/section';

import { useWeekDate } from '../../contexts/timeframe';
import { HabitsList } from '../habits-list';

export const ArchivedHabitsList: React.FC = () => {
  const { t } = useTranslation();
  const weekDate = useWeekDate();
  const habits = useHabits({ archivedOnly: true });

  if (!habits.length) {
    return null;
  }

  return (
    <Section
      title={t('pages.habits.archived-section.title')}
      titleCount={habits.length}
      size={Sizes.Small}
      canCollapse
    >
      <HabitsList items={habits} weekDate={weekDate} />
    </Section>
  );
};
